import { useUpdateAccount } from '../../../../hooks';
import { ESP_ACCOUNT_PAYLOAD_FIELDS } from '../../../../types';
import { ConnectedInputField } from '../../Shared/ConnectedInputField';
import { ClearableConnectedInputField } from '../../Shared/ClearableConnectedInputField';
import { EditModalRHF } from '../../Shared/EditModalRHF';

const { NAME, API_KEY, API_ENDPOINT, EDIT_API_KEY } = ESP_ACCOUNT_PAYLOAD_FIELDS;

export const TwilioEditModal = () => {
  const { updateAccount } = useUpdateAccount();

  return (
    <EditModalRHF onSubmit={updateAccount}>
      <ConnectedInputField
        name={NAME}
        labelText="API key SID"
        placeholder="SKxxxxxxxxxxxxxxxx"
        data-test="name-input"
      />
      <ClearableConnectedInputField
        name={API_KEY}
        labelText="API key secret"
        wasEditedFieldName={EDIT_API_KEY}
        data-test="apiKey-input"
      />
      <ConnectedInputField
        name={API_ENDPOINT}
        labelText="Account SID"
        placeholder="ACxxxxxxxxxxxxxxxx"
        data-test="apiEndpoint-input"
      />
    </EditModalRHF>
  );
};
